var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCardWrapped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15515,
    y: 0.5,
    width: 34.5862,
    height: 23,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4583 16.2582H9.30248L7.68587 10.1924C7.60914 9.91334 7.44622 9.66666 7.20656 9.5504C6.60848 9.25823 5.94943 9.0257 5.23047 8.90843V8.67489H8.70335C9.18266 8.67489 9.54214 9.0257 9.60205 9.43313L10.4408 13.8086L12.5956 8.67489H14.6915L11.4583 16.2582ZM15.8898 16.2582H13.8538L15.5303 8.67489H17.5663L15.8898 16.2582ZM20.2004 10.7757C20.2603 10.3673 20.6198 10.1337 21.0392 10.1337C21.6983 10.0751 22.4162 10.1924 23.0153 10.4835L23.3748 8.85081C22.7757 8.61727 22.1166 8.5 21.5185 8.5C19.5424 8.5 18.1045 9.55041 18.1045 11.0082C18.1045 12.1173 19.123 12.6996 19.842 13.0504C20.6198 13.4002 20.9194 13.6338 20.8595 13.9835C20.8595 14.5082 20.2603 14.7418 19.6623 14.7418C18.9433 14.7418 18.2243 14.5669 17.5663 14.2747L17.2069 15.9085C17.9258 16.1996 18.7036 16.3169 19.4226 16.3169C21.6384 16.3745 23.0153 15.3251 23.0153 13.75C23.0153 11.7665 20.2004 11.6502 20.2004 10.7757ZM30.1408 16.2582L28.5242 8.67489H26.7878C26.4283 8.67489 26.0688 8.90843 25.949 9.25823L22.9554 16.2582H25.0513L25.4697 15.1502H28.0449L28.2846 16.2582H30.1408ZM27.0873 10.7171L27.6854 13.5751H26.0089L27.0873 10.7171Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardWrapped);
export default __webpack_public_path__ + "static/media/visa-card-wrapped.10dd1baf4c918ad0551454fc93948581.svg";
export { ForwardRef as ReactComponent };